
import { ACTIVE_PROFILE } from '../config';
import { combineReducers, createStore, applyMiddleware, compose } from 'redux';
// import { createLogger } from 'redux-logger';
import thunkMiddleware from 'redux-thunk';

// Reducers
import loadingReducer from './loading/reducer';
import authReducer from './auth/reducer';
import loyaltyReducer from './loyalty/reducer';
import campaignsReducer from './campaigns/reducer';
import answersReducer from './answers/reducer';
import mixpanelReducer from './mixpanel/reducer';
import dcmReducer from "./dcm/reducer";

const reducer = combineReducers({
  loading: loadingReducer,
  auth: authReducer,
  loyalty: loyaltyReducer,
  campaigns: campaignsReducer,
  answers: answersReducer,
  mixpanel: mixpanelReducer,
  dcm: dcmReducer,
});

// Middleware
// const loggerMiddleware = createLogger({
  // For Edge
  // stateTransformer: state => JSON.stringify(state)
// });
const middleware = applyMiddleware(
  thunkMiddleware,
  // loggerMiddleware
);

const composeEnhancers = (ACTIVE_PROFILE === 'test' && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__)
    ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
    : compose;

const store = createStore(
  reducer,
  composeEnhancers(middleware)
);


export default store;



// WEBPACK FOOTER //
// ./src/redux/store.js